export enum flowScreenEnum {
  S0 = 'ExternalAuth', // entrance screen - always existing customer

  S20 = 'PersonalInformation', // entrance screen - new or existing customer, cpo for example can be existing
  S1 = 'PersonalInformation2',

  S2 = 'VerifyDetails',
  S3 = 'SelectPhonenumberInput',
  S4 = 'SelectPhonenumberList',

  S5 = 'InstallationCoordination',

  S6 = 'MovingInstallAddress',

  S7 = 'MovingSelectPhone',

  S8 = 'MovingOffers',

  S9 = 'SelectDevice',
  S10 = 'PaymentDetails',
  S11 = 'CoordinationInstallationTime',
  S12 = 'SelectNumberToPhone',
  S26 = 'ErrorNotPossible',
  S19 = 'ExchangePackages',
  // S6 = "BitQuestion",
  S13 = 'DeliveryCoordination',
  S14 = 'ThankAndEn',

  S27 = 'UpgradePersonalInformation',

  S28 = 'IdPhone', // entrance screen - always existing customer

  S29 = 'Identification', // entrance screen - always existing customer
  S30 = 'ResetPassword',
  S31 = 'ResetPasswordCheck',
  S18 = 'UpdatePersonalDetails',
  S32 = 'WSFilterPersonalDetails',

  // Electricity
  S101 = 'PersonalInformationElectricity',// entrance screen - new or existing customer
  S117 = 'SMSOrbotCodeElectricity',
  S118 = 'ExchangePackagesElectricity',
  S102 = 'VerifyDetailsElectricity',
  S116 = 'SMSVerificationCodeElectricity',
  S105 = 'InstallationCoordinationElectricity',
  // S117 = 'TODO_NEW_InstallationCoordinationNewCustomerElectricity',
  // S115 = 'TODO_NEW_PaymentMethodSelectElectricity',
  S110 = 'PaymentDetailsElectricity',
  S120 = 'NoSmartMeterEndElectricity',
  S114 = 'ThankAndEndElectricity'
}
